export const flagsPermissions = {
    VIEW_FLAGS: {
        key: 'flags.view',
        name: 'View Flags',
    },
    EDIT_FLAGS: {
        key: 'flags.edit',
        name: 'Edit Flags',
    }
}